<template>
  <div class="login_container">
    <div class="login_box">
      <!-- LOGO -->
      <div class="avatar_box">
        <img src="../assets/logo.png" alt />
      </div>
      
      <!-- 表单 -->
      <el-form
        ref="LoginFormRef"
        :model="loginForm"
        label-width="0"
        :rules="LoginFormRules"
        class="login_form"
      >
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" prefix-icon="el-icon-user" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" prefix-icon="el-icon-lock" type="password" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item class="btns">
          <el-button type="primary" @click="login" size="small" style="width:360px">登录</el-button><br>
          <el-button type="info" @click="resetLoginForm" size="small" style="width:360px">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="introduceBox">
      <h1 class="bigTitle">新冠肺炎建模平台</h1>
      <div class="introText">将深度学习算法应用于临床胸部CT图像，实现全自动识别肺部新冠肺炎病灶区域，三维可视化并进行体积定量分析，辅助临床新冠肺炎患者病情诊断。</div>
      <h1 class="danwei">合作单位</h1>
      <div class="cardsDiv">
        <div style="width:140px;height:140px;margin-right:10px;float:left;"><img src="../assets/hit.jpg" alt="" style="width:100%;height:100%;"></div>
        <div style="width:140px;height:140px;margin-right:10px;float:left;"><img src="../assets/linda.jpg" alt="" style="width:100%;height:100%;"></div>
        <div style="width:140px;height:140px;margin-right:10px;float:left;"><img src="../assets/hayida.jpg" alt="" style="width:100%;height:100%;"></div>
        <div style="width:140px;height:140px;margin-right:10px;float:left;"><img src="../assets/tmkj.jpg" alt="" style="width:100%;height:100%;"></div>
      </div>
      <h1 class="contactus">联系我们</h1>
      <div class="contactText">
        账号申请邮箱：luogongning@hit.edu.cn &nbsp;&nbsp;&nbsp;
        联系人邮箱：wangkq@hit.edu.cn
      </div>
    </div>
    <!-- <div class="cardsDiv">
      
    </div> -->
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      loginForm: {
        username: "",
        password: ""
      },
      LoginFormRules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  methods: {
    resetLoginForm() {
      this.$refs.LoginFormRef.resetFields();
    },
    login() {
      this.$refs["LoginFormRef"].validate(async valid => {
        if (!valid) return;
        const { data } = await this.$http.post("login", this.loginForm);
          if (data.status === 100) {
            window.sessionStorage.setItem("token", data.data.token);
            this.$router.push("/home");
            this.$message({
              message: "登陆成功",
              type: "success"
            });
          }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.login_container {
  background-color: #2b4b6b;
  height: 100%;
}
.bigTitle {
  position: absolute;
  // background-color: red;
  font-size: 30px;
  color: #FFF;
  font-weight: 400;
}
.danwei {
  position: absolute;
  // background-color: red;
  font-size: 20px;
  color: #FFF;
  font-weight: 400;
  top : 200px;
}
.contactus{
  position: absolute;
  font-size: 20px;
  color: #FFF;
  font-weight: 400;
  top : 400px;
}
.introText {
  position: absolute;
  // background-color: gold;
  top:100px;
  width: 560px;
  color: #FFF;
  line-height: 26px;
  font-size: 14px;
}
.contactText{
  position: absolute;
  top:450px;
  width: 560px;
  color: #FFF;
  line-height: 26px;
  font-size: 14px;
}
.subIntroText {
  color: #FFF;
  line-height: 20px;
  font-size: 12px;
}
.login_box {
  width: 400px;
  height: 350px;
  background-color: #fff;
  border-radius: 3px;
  position: absolute;
  right: 10%;
  top: 50%;
  transform: translate(0%, -50%);
}
.cardsDiv{
  width: 600px;
  height: 200px;
  // background-color: gray;
  position: absolute;
  top:250px;
}
.introduceBox {
  width:500px;
  height: 500px;
  // background-color: #eee;
  position: absolute;
  left: 10%;
  top: 50%;
  transform: translate(0%, -50%);
}
.avatar_box {
  width: 130px;
  height: 130px;
  border: 1px solid #eee;
  border-radius: 50%;
  padding: 10px;
  box-shadow: 0 0 10px #ddd;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #eee;
  }
}

.login_form {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.btns {
  display: flex;
  justify-content: flex-end;
}


.time {
    font-size: 13px;
    color: #999;
  }
  
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    height: 200px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }
</style>>

